import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

type RestaurantContextType = {
  restaurantId: string;
  saveRestaurantId: (restaurantId: string) => void;
  deleteRestaurantId: () => void;
};

export const initialContext: RestaurantContextType = {
  restaurantId: '',
  saveRestaurantId: () => {},
  deleteRestaurantId: () => {}
};

export const RestaurantContext = createContext<RestaurantContextType>(initialContext);

export const RestaurantProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [restaurantId, setRestaurantId] = useState('');

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const saveRestaurantId = (restaurantId: string) => {
    setRestaurantId(restaurantId);
  };

  const deleteRestaurantId = () => {
    setRestaurantId('');
    queryClient.removeQueries('restaurant');
  };

  const contextValue: RestaurantContextType = {
    restaurantId,
    deleteRestaurantId,
    saveRestaurantId
  };

  return <RestaurantContext.Provider value={contextValue}>{children}</RestaurantContext.Provider>;
};

export const useRestaurantContext = () => {
  const context = useContext(RestaurantContext);
  if (context === undefined) {
    throw new Error('RestaurantContext must be within RestaurantProvider');
  }

  return context;
};
